
import React, { useState, useEffect, useMemo } from 'react';
import { styled } from '@mui/material/styles';
import {
  Box,
  Container,
  Grid,
  Typography,
  Paper,
  Card,
  CardContent,
  TextField,
  Button,
  FormControlLabel,
  IconButton,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Avatar,
  Chip,
  Tooltip,
  CircularProgress,
  Alert,
  AlertTitle,
  Breadcrumbs,
  Stepper,
  Step,
  StepLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Divider,
  Stack,
  Badge,
  LinearProgress,
  Fade,
  Collapse,
  useTheme,
  useMediaQuery,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,


} from '@mui/material';

// Icons
import {
  Edit as EditIcon,
  Photo as PhotoIcon,
  Star as StarIcon,
  Send as SendIcon,
  Save as SaveIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
  Close as CloseIcon,
  CloudUpload as CloudUploadIcon,
  Person as PersonIcon,
  PersonAdd as PersonAddIcon,
  Group as GroupIcon,
  Settings as SettingsIcon,
  Language as LanguageIcon,
  Schedule as ScheduleIcon,
  Speed as SpeedIcon,
  Code as CodeIcon,
  Assessment as AssessmentIcon,
  ExpandMore as ExpandMoreIcon,
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  ErrorOutline as ErrorIcon,
  ArrowBack as ArrowBackIcon,
  Visibility as VisibilityIcon
} from '@mui/icons-material';
import S3FileUpload from 'react-s3';
import { useCredentials } from '../useCredentials';

import AWS from 'aws-sdk';
import axios from 'axios';
import moment from 'moment';
import { useAuthToken } from "../TokenContext";
import { useIntl } from 'react-intl';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useSelector } from "react-redux";
import defaultimg from './assets/defaultimge.png';
import ImageUploadComponent from './ImageUploadComponent';
import { useSearchParams } from 'react-router-dom';



const PodImageUpload = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: 120,
  height: 120,
  margin: '0 auto',
  marginBottom: theme.spacing(3),
}));



const UploadButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: -8,
  bottom: -8,
  backgroundColor: theme.palette.primary.main,
  color: '#fff',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));







// Styled Components with dark mode support
const PageContainer = styled(Container)(({ theme, collapsed }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(4),
  width: '100%',
  maxWidth: '100%',
  background: 'transparent',
}));

const MainCard = styled(Card)(({ theme }) => ({
  marginTop: theme.spacing(2),
  borderRadius: 14,
  boxShadow: 'none',
  overflow: 'visible',
  background: 'var(--artemy-bg-card)',
  border: '1px solid var(--artemy-border)',
  transition: 'border-color 0.2s',
  '&:hover': {
    borderColor: 'var(--artemy-border-bright)',
  },
}));

const FormSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  margin: theme.spacing(2, 0),
  borderRadius: 12,
  backgroundColor: 'var(--artemy-bg-elevated)',
  border: '1px solid var(--artemy-border)',
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: 120,
  height: 120,
  border: `4px solid ${theme.palette.mode === 'dark' ? '#2d2d2d' : '#fff'}`,
  boxShadow: theme.palette.mode === 'dark'
    ? '0 4px 12px rgba(0, 0, 0, 0.3)'
    : '0 4px 12px rgba(0, 0, 0, 0.15)',
  cursor: 'pointer',
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: theme.palette.mode === 'dark'
      ? '0 6px 16px rgba(0, 0, 0, 0.4)'
      : '0 6px 16px rgba(0, 0, 0, 0.2)',
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 8,
    backgroundColor: 'var(--artemy-bg-elevated)',
    color: 'var(--artemy-text-primary)',
    transition: 'all 0.2s ease',
    '& fieldset': {
      borderColor: 'var(--artemy-border)',
    },
    '&:hover fieldset': {
      borderColor: 'var(--artemy-border-bright)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'var(--artemy-accent)',
    },
  },
  '& .MuiInputLabel-root': {
    color: 'var(--artemy-text-secondary)',
    '&.Mui-focused': {
      color: 'var(--artemy-accent)',
    },
  },
  '& .MuiInputBase-input': {
    color: 'var(--artemy-text-primary)',
  },
}));

const StyledSelect = styled(FormControl)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 8,
    backgroundColor: 'var(--artemy-bg-elevated)',
    color: 'var(--artemy-text-primary)',
    transition: 'all 0.2s ease',
    '& fieldset': {
      borderColor: 'var(--artemy-border)',
    },
    '&:hover fieldset': {
      borderColor: 'var(--artemy-border-bright)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'var(--artemy-accent)',
    },
  },
  '& .MuiInputLabel-root': {
    color: 'var(--artemy-text-secondary)',
    '&.Mui-focused': {
      color: 'var(--artemy-accent)',
    },
  },
  '& .MuiSelect-icon': {
    color: 'var(--artemy-text-secondary)',
  },
}));

const ActionButton = styled(Button)(({ theme, variant = 'contained' }) => ({
  borderRadius: 8,
  padding: '8px 24px',
  textTransform: 'none',
  fontWeight: 600,
  fontFamily: 'var(--artemy-font-body)',
  backgroundColor: variant === 'contained' ? 'var(--artemy-accent)' : 'transparent',
  color: variant === 'contained' ? '#fff' : 'var(--artemy-accent)',
  border: variant === 'outlined' ? '1px solid var(--artemy-accent)' : 'none',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: variant === 'contained' ? '#3570e5' : 'rgba(61,127,255,0.08)',
    boxShadow: 'none',
  },
}));

const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  '& .MuiBreadcrumbs-separator': {
    margin: theme.spacing(0, 1),
    color: theme.palette.mode === 'dark' ? '#fff' : 'inherit',
  },
  '& a': {
    color: theme.palette.mode === 'dark' ? '#90caf9' : theme.palette.primary.main,
    textDecoration: 'none',
    fontWeight: 600,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

const ImageUploadWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: 120,
  height: 120,
  margin: '0 auto',
  marginBottom: theme.spacing(3),
}));

const ImagePlaceholder = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.mode === 'dark' ? '#1e1e1e' : theme.palette.grey[100],
  borderRadius: '50%',
}));

const UploadIconButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: -8,
  bottom: -8,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, 0.12)'
      : theme.palette.grey[400],
  }
}));

// Update TeamMemberCard with dark mode support
const TeamMemberCard = styled(Card)(({ theme }) => ({
  padding: '16px',
  borderRadius: '12px',
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  marginBottom: '8px',
  transition: 'all 0.2s ease',
  cursor: 'pointer',
  backgroundColor: 'var(--artemy-bg-elevated)',
  border: '1px solid var(--artemy-border)',
  boxShadow: 'none',
  '&:hover': {
    transform: 'translateX(4px)',
    borderColor: 'var(--artemy-accent)',
  }
}));

const StatusChip = styled(Chip)(({ status }) => {
  const getStatusColor = () => {
    const colors = {
      active: {
        bg: '#4caf50',
        text: '#fff'
      },
      inactive: {
        bg: '#f44336',
        text: '#fff'
      },
      pending: {
        bg: '#ff9800',
        text: '#fff'
      }
    };
    return colors[status?.toLowerCase()] || colors.active;
  };

  const statusColor = getStatusColor();
  return {
    backgroundColor: statusColor.bg,
    color: statusColor.text,
    fontWeight: 600,
    '& .MuiChip-icon': {
      color: statusColor.text,
    },
  };
});



// Utility Functions
const formatDate = (date) => moment(date).format('MMM DD, YYYY');

const getStatusIcon = (status) => {
  switch (status?.toLowerCase()) {
    case 'active':
      return <CheckCircleIcon />;
    case 'inactive':
      return <ErrorIcon />;
    case 'pending':
      return <WarningIcon />;
    default:
      return <CheckCircleIcon />;
  }
};

// Enhanced image upload functionality with proper error handling and validation

// const generateImageUrl = async (key, s3) => {
//   if (!key) return null;
//   try {
//     return await s3.getSignedUrl('getObject', {
//       Bucket: s3Config.bucketName,
//       Key: key,
//       Expires: 3600
//     });
//   } catch (error) {
//     console.error('Error generating image URL:', error);
//     return null;
//   }
// };

// Constants
const POD_TYPES = [
  { value: 'SaaS', label: 'SaaS' },
  { value: 'Web + Mobile App', label: 'Web + Mobile App' },
  { value: 'Web App', label: 'Web App' },
  { value: 'Mobile App', label: 'Mobile App' },
  { value: 'Data & AI', label: 'Data & AI' }
];

const TECH_STACKS = [
  { value: 'MEAN', label: 'MEAN Stack' },
  { value: 'MERN', label: 'MERN Stack' },
  { value: 'LAMP', label: 'LAMP Stack' },
  { value: 'MEVN', label: 'MEVN Stack' }
];

const POD_SIZES = [
  { value: '3', label: '3 Members' },
  { value: '5', label: '5 Members' },
  { value: '7', label: '7 Members' },
  { value: '9', label: '9 Members' }
];

const PRIMARY_LANGUAGES = [
  { value: 'aa', label: 'Afar' },
  { value: 'ab', label: 'Abkhazian' },
  { value: 'ae', label: 'Avestan' },
  { value: 'af', label: 'Afrikaans' },
  { value: 'ak', label: 'Akan' },
  { value: 'am', label: 'Amharic' },
  { value: 'an', label: 'Aragonese' },
  { value: 'ar', label: 'Arabic' },
  { value: 'as', label: 'Assamese' },
  { value: 'av', label: 'Avaric' },
  { value: 'ay', label: 'Aymara' },
  { value: 'az', label: 'Azerbaijani' },
  { value: 'ba', label: 'Bashkir' },
  { value: 'be', label: 'Belarusian' },
  { value: 'bg', label: 'Bulgarian' },
  { value: 'bh', label: 'Bihari languages' },
  { value: 'bi', label: 'Bislama' },
  { value: 'bm', label: 'Bambara' },
  { value: 'bn', label: 'Bengali' },
  { value: 'bo', label: 'Tibetan' },
  { value: 'br', label: 'Breton' },
  { value: 'bs', label: 'Bosnian' },
  { value: 'ca', label: 'Catalan' },
  { value: 'ce', label: 'Chechen' },
  { value: 'ch', label: 'Chamorro' },
  { value: 'co', label: 'Corsican' },
  { value: 'cr', label: 'Cree' },
  { value: 'cs', label: 'Czech' },
  { value: 'cu', label: 'Church Slavic' },
  { value: 'cv', label: 'Chuvash' },
  { value: 'cy', label: 'Welsh' },
  { value: 'da', label: 'Danish' },
  { value: 'de', label: 'German' },
  { value: 'dv', label: 'Divehi' },
  { value: 'dz', label: 'Dzongkha' },
  { value: 'ee', label: 'Ewe' },
  { value: 'el', label: 'Greek' },
  { value: 'en', label: 'English' },
  { value: 'eo', label: 'Esperanto' },
  { value: 'es', label: 'Spanish' },
  { value: 'et', label: 'Estonian' },
  { value: 'eu', label: 'Basque' },
  { value: 'fa', label: 'Persian' },
  { value: 'ff', label: 'Fulah' },
  { value: 'fi', label: 'Finnish' },
  { value: 'fj', label: 'Fijian' },
  { value: 'fo', label: 'Faroese' },
  { value: 'fr', label: 'French' },
  { value: 'fy', label: 'Western Frisian' },
  { value: 'ga', label: 'Irish' },
  { value: 'gd', label: 'Gaelic' },
  { value: 'gl', label: 'Galician' },
  { value: 'gn', label: 'Guarani' },
  { value: 'gu', label: 'Gujarati' },
  { value: 'gv', label: 'Manx' },
  { value: 'ha', label: 'Hausa' },
  { value: 'he', label: 'Hebrew' },
  { value: 'hi', label: 'Hindi' },
  { value: 'ho', label: 'Hiri Motu' },
  { value: 'hr', label: 'Croatian' },
  { value: 'ht', label: 'Haitian' },
  { value: 'hu', label: 'Hungarian' },
  { value: 'hy', label: 'Armenian' },
  { value: 'hz', label: 'Herero' },
  { value: 'ia', label: 'Interlingua' },
  { value: 'id', label: 'Indonesian' },
  { value: 'ie', label: 'Interlingue' },
  { value: 'ig', label: 'Igbo' },
  { value: 'ii', label: 'Sichuan Yi' },
  { value: 'ik', label: 'Inupiaq' },
  { value: 'io', label: 'Ido' },
  { value: 'is', label: 'Icelandic' },
  { value: 'it', label: 'Italian' },
  { value: 'iu', label: 'Inuktitut' },
  { value: 'ja', label: 'Japanese' },
  { value: 'jv', label: 'Javanese' },
  { value: 'ka', label: 'Georgian' },
  { value: 'kg', label: 'Kongo' },
  { value: 'ki', label: 'Kikuyu' },
  { value: 'kj', label: 'Kuanyama' },
  { value: 'kk', label: 'Kazakh' },
  { value: 'kl', label: 'Kalaallisut' },
  { value: 'km', label: 'Central Khmer' },
  { value: 'kn', label: 'Kannada' },
  { value: 'ko', label: 'Korean' },
  { value: 'kr', label: 'Kanuri' },
  { value: 'ks', label: 'Kashmiri' },
  { value: 'ku', label: 'Kurdish' },
  { value: 'kv', label: 'Komi' },
  { value: 'kw', label: 'Cornish' },
  { value: 'ky', label: 'Kirghiz' },
  { value: 'la', label: 'Latin' },
  { value: 'lb', label: 'Luxembourgish' },
  { value: 'lg', label: 'Ganda' },
  { value: 'li', label: 'Limburgan' },
  { value: 'ln', label: 'Lingala' },
  { value: 'lo', label: 'Lao' },
  { value: 'lt', label: 'Lithuanian' },
  { value: 'lu', label: 'Luba-Katanga' },
  { value: 'lv', label: 'Latvian' },
  { value: 'mg', label: 'Malagasy' },
  { value: 'mh', label: 'Marshallese' },
  { value: 'mi', label: 'Maori' },
  { value: 'mk', label: 'Macedonian' },
  { value: 'ml', label: 'Malayalam' },
  { value: 'mn', label: 'Mongolian' },
  { value: 'mr', label: 'Marathi' },
  { value: 'ms', label: 'Malay' },
  { value: 'mt', label: 'Maltese' },
  { value: 'my', label: 'Burmese' },
  { value: 'na', label: 'Nauru' },
  { value: 'nb', label: 'Norwegian Bokmål' },
  { value: 'nd', label: 'North Ndebele' },
  { value: 'ne', label: 'Nepali' },
  { value: 'ng', label: 'Ndonga' },
  { value: 'nl', label: 'Dutch' },
  { value: 'nn', label: 'Norwegian Nynorsk' },
  { value: 'no', label: 'Norwegian' },
  { value: 'nr', label: 'South Ndebele' },
  { value: 'nv', label: 'Navajo' },
  { value: 'ny', label: 'Nyanja' },
  { value: 'oc', label: 'Occitan' },
  { value: 'oj', label: 'Ojibwa' },
  { value: 'om', label: 'Oromo' },
  { value: 'or', label: 'Oriya' },
  { value: 'os', label: 'Ossetian' },
  { value: 'pa', label: 'Panjabi' },
  { value: 'pi', label: 'Pali' },
  { value: 'pl', label: 'Polish' },
  { value: 'ps', label: 'Pushto' },
  { value: 'pt', label: 'Portuguese' },
  { value: 'qu', label: 'Quechua' },
  { value: 'rm', label: 'Romansh' },
  { value: 'rn', label: 'Rundi' },
  { value: 'ro', label: 'Romanian' },
  { value: 'ru', label: 'Russian' },
  { value: 'rw', label: 'Kinyarwanda' },
  { value: 'sa', label: 'Sanskrit' },
  { value: 'sc', label: 'Sardinian' },
  { value: 'sd', label: 'Sindhi' },
  { value: 'se', label: 'Northern Sami' },
  { value: 'sg', label: 'Sango' },
  { value: 'si', label: 'Sinhala' },
  { value: 'sk', label: 'Slovak' },
  { value: 'sl', label: 'Slovenian' },
  { value: 'sm', label: 'Samoan' },
  { value: 'sn', label: 'Shona' },
  { value: 'so', label: 'Somali' },
  { value: 'sq', label: 'Albanian' },
  { value: 'sr', label: 'Serbian' },
  { value: 'ss', label: 'Swati' },
  { value: 'st', label: 'Southern Sotho' },
  { value: 'su', label: 'Sundanese' },
  { value: 'sv', label: 'Swedish' },
  { value: 'sw', label: 'Swahili' },
  { value: 'ta', label: 'Tamil' },
  { value: 'te', label: 'Telugu' },
  { value: 'tg', label: 'Tajik' },
  { value: 'th', label: 'Thai' },
  { value: 'ti', label: 'Tigrinya' },
  { value: 'tk', label: 'Turkmen' },
  { value: 'tl', label: 'Tagalog' },
  { value: 'tn', label: 'Tswana' },
  { value: 'to', label: 'Tonga' },
  { value: 'tr', label: 'Turkish' },
  { value: 'ts', label: 'Tsonga' },
  { value: 'tt', label: 'Tatar' },
  { value: 'tw', label: 'Twi' },
  { value: 'ty', label: 'Tahitian' },
  { value: 'ug', label: 'Uighur' },
  { value: 'uk', label: 'Ukrainian' },
  { value: 'ur', label: 'Urdu' },
  { value: 'uz', label: 'Uzbek' },
  { value: 've', label: 'Venda' },
  { value: 'vi', label: 'Vietnamese' },
  { value: 'vo', label: 'Volapük' },
  { value: 'wa', label: 'Walloon' },
  { value: 'wo', label: 'Wolof' },
  { value: 'xh', label: 'Xhosa' },
  { value: 'yi', label: 'Yiddish' },
  { value: 'yo', label: 'Yoruba' },
  { value: 'za', label: 'Zhuang' },
  { value: 'zh', label: 'Chinese' },
  { value: 'zu', label: 'Zulu' }

];

const TIMEZONES = [
  { value: 'africa_abidjan', label: 'Africa/Abidjan' },
  { value: 'africa_accra', label: 'Africa/Accra' },
  { value: 'africa_addis_ababa', label: 'Africa/Addis Ababa' },
  { value: 'africa_algiers', label: 'Africa/Algiers' },
  { value: 'africa_asmara', label: 'Africa/Asmara' },
  { value: 'africa_bamako', label: 'Africa/Bamako' },
  { value: 'africa_bangui', label: 'Africa/Bangui' },
  { value: 'africa_banjul', label: 'Africa/Banjul' },
  { value: 'africa_bissau', label: 'Africa/Bissau' },
  { value: 'africa_blantyre', label: 'Africa/Blantyre' },
  { value: 'africa_brazzaville', label: 'Africa/Brazzaville' },
  { value: 'africa_bujumbura', label: 'Africa/Bujumbura' },
  { value: 'africa_casablanca', label: 'Africa/Casablanca' },
  { value: 'africa_ceuta', label: 'Africa/Ceuta' },
  { value: 'africa_conakry', label: 'Africa/Conakry' },
  { value: 'africa_dakar', label: 'Africa/Dakar' },
  { value: 'africa_dar_es_salaam', label: 'Africa/Dar es Salaam' },
  { value: 'africa_djibouti', label: 'Africa/Djibouti' },
  { value: 'africa_douala', label: 'Africa/Douala' },
  { value: 'africa_el_aaiun', label: 'Africa/El Aaiun' },
  { value: 'africa_freetown', label: 'Africa/Freetown' },
  { value: 'africa_gaborone', label: 'Africa/Gaborone' },
  { value: 'africa_harare', label: 'Africa/Harare' },
  { value: 'africa_johannesburg', label: 'Africa/Johannesburg' },
  { value: 'africa_juba', label: 'Africa/Juba' },
  { value: 'africa_kampala', label: 'Africa/Kampala' },
  { value: 'africa_khartoum', label: 'Africa/Khartoum' },
  { value: 'africa_kigali', label: 'Africa/Kigali' },
  { value: 'africa_kinshasa', label: 'Africa/Kinshasa' },
  { value: 'africa_lagos', label: 'Africa/Lagos' },
  { value: 'africa_libreville', label: 'Africa/Libreville' },
  { value: 'africa_lome', label: 'Africa/Lome' },
  { value: 'africa_luanda', label: 'Africa/Luanda' },
  { value: 'africa_lubumbashi', label: 'Africa/Lubumbashi' },
  { value: 'africa_lusaka', label: 'Africa/Lusaka' },
  { value: 'africa_malabo', label: 'Africa/Malabo' },
  { value: 'africa_maputo', label: 'Africa/Maputo' },
  { value: 'africa_maseru', label: 'Africa/Maseru' },
  { value: 'africa_mbabane', label: 'Africa/Mbabane' },
  { value: 'africa_mogadishu', label: 'Africa/Mogadishu' },
  { value: 'africa_monrovia', label: 'Africa/Monrovia' },
  { value: 'africa_nairobi', label: 'Africa/Nairobi' },
  { value: 'africa_ndjamena', label: 'Africa/Ndjamena' },
  { value: 'africa_niamey', label: 'Africa/Niamey' },
  { value: 'africa_nouakchott', label: 'Africa/Nouakchott' },
  { value: 'africa_ouagadougou', label: 'Africa/Ouagadougou' },
  { value: 'africa_porto-novo', label: 'Africa/Porto-Novo' },
  { value: 'africa_sao_tome', label: 'Africa/Sao Tome' },
  { value: 'africa_tripoli', label: 'Africa/Tripoli' },
  { value: 'africa_tunis', label: 'Africa/Tunis' },
  { value: 'africa_windhoek', label: 'Africa/Windhoek' },
  { value: 'america_adak', label: 'America/Adak' },
  { value: 'america_anchorage', label: 'America/Anchorage' },
  { value: 'america_anguilla', label: 'America/Anguilla' },
  { value: 'america_antigua', label: 'America/Antigua' },
  { value: 'america_araguaina', label: 'America/Araguaina' },
  { value: 'america_argentina_buenos_aires', label: 'America/Argentina/Buenos Aires' },
  { value: 'america_argentina_catamarca', label: 'America/Argentina/Catamarca' },
  { value: 'america_argentina_comodrivadavia', label: 'America/Argentina/Comodrivadavia' },
  { value: 'america_argentina_cordoba', label: 'America/Argentina/Cordoba' },
  { value: 'america_argentina_jujuy', label: 'America/Argentina/Jujuy' },
  { value: 'america_argentina_la_rioja', label: 'America/Argentina/La Rioja' },
  { value: 'america_argentina_mendoza', label: 'America/Argentina/Mendoza' },
  { value: 'america_argentina_rio_gallegos', label: 'America/Argentina/Rio Gallegos' },
  { value: 'america_argentina_salta', label: 'America/Argentina/Salta' },
  { value: 'america_argentina_san_juan', label: 'America/Argentina/San Juan' },
  { value: 'america_argentina_san_luis', label: 'America/Argentina/San Luis' },
  { value: 'america_argentina_tucuman', label: 'America/Argentina/Tucuman' },
  { value: 'america_argentina_ushuaia', label: 'America/Argentina/Ushuaia' },
  { value: 'america_aruba', label: 'America/Aruba' },
  { value: 'america_asuncion', label: 'America/Asuncion' },
  { value: 'america_atikokan', label: 'America/Atikokan' },
  { value: 'america_bahia', label: 'America/Bahia' },
  { value: 'america_bahia_banderas', label: 'America/Bahia Banderas' },
  { value: 'america_barbados', label: 'America/Barbados' },
  { value: 'america_belem', label: 'America/Belem' },
  { value: 'america_belize', label: 'America/Belize' },
  { value: 'america_blanc-sablon', label: 'America/Blanc-Sablon' },
  { value: 'america_boa_vista', label: 'America/Boa Vista' },
  { value: 'america_bogota', label: 'America/Bogota' },
  { value: 'america_boise', label: 'America/Boise' },
  { value: 'america_cambridge_bay', label: 'America/Cambridge Bay' },
  { value: 'america_campo_grande', label: 'America/Campo Grande' },
  { value: 'america_cancun', label: 'America/Cancun' },
  { value: 'america_caracas', label: 'America/Caracas' },
  { value: 'america_cayenne', label: 'America/Cayenne' },
  { value: 'america_cayman', label: 'America/Cayman' },
  { value: 'america_chicago', label: 'America/Chicago' },
  { value: 'america_chihuahua', label: 'America/Chihuahua' },
  { value: 'america_coral_harbour', label: 'America/Coral Harbour' },
  { value: 'america_costa_rica', label: 'America/Costa Rica' },
  { value: 'america_creston', label: 'America/Creston' },
  { value: 'america_cuiaba', label: 'America/Cuiaba' },
  { value: 'america_curacao', label: 'America/Curacao' },
  { value: 'america_danmarkshavn', label: 'America/Danmarkshavn' },
  { value: 'america_dawson', label: 'America/Dawson' },
  { value: 'america_dawson_creek', label: 'America/Dawson Creek' },
  { value: 'america_denver', label: 'America/Denver' },
  { value: 'america_detroit', label: 'America/Detroit' },
  { value: 'america_dominica', label: 'America/Dominica' },
  { value: 'america_edmonton', label: 'America/Edmonton' },
  { value: 'america_eirunepe', label: 'America/Eirunepe' },
  { value: 'america_el_salvador', label: 'America/El Salvador' },
  { value: 'america_fort_nelson', label: 'America/Fort Nelson' },
  { value: 'america_fortaleza', label: 'America/Fortaleza' },
  { value: 'america_glace_bay', label: 'America/Glace Bay' },
  { value: 'america_godthab', label: 'America/Godthab' },
  { value: 'america_goose_bay', label: 'America/Goose Bay' },
  { value: 'america_grand_turk', label: 'America/Grand Turk' },
  { value: 'america_grenada', label: 'America/Grenada' },
  { value: 'america_guadeloupe', label: 'America/Guadeloupe' },
  { value: 'america_guatemala', label: 'America/Guatemala' },
  { value: 'america_guayaquil', label: 'America/Guayaquil' },
  { value: 'america_guyana', label: 'America/Guyana' },
  { value: 'america_halifax', label: 'America/Halifax' },
  { value: 'america_havana', label: 'America/Havana' },
  { value: 'america_hermosillo', label: 'America/Hermosillo' },
  { value: 'america_indiana_indianapolis', label: 'America/Indiana/Indianapolis' },
  { value: 'america_indiana_knox', label: 'America/Indiana/Knox' },
  { value: 'america_indiana_marengo', label: 'America/Indiana/Marengo' },
  { value: 'america_indiana_petersburg', label: 'America/Indiana/Petersburg' },
  { value: 'america_indiana_tell_city', label: 'America/Indiana/Tell City' },
  { value: 'america_indiana_vevay', label: 'America/Indiana/Vevay' },
  { value: 'america_indiana_vincennes', label: 'America/Indiana/Vincennes' },
  { value: 'america_indiana_winamac', label: 'America/Indiana/Winamac' },
  { value: 'america_inuvik', label: 'America/Inuvik' },
  { value: 'america_iqaluit', label: 'America/Iqaluit' },
  { value: 'america_jamaica', label: 'America/Jamaica' },
  { value: 'america_juneau', label: 'America/Juneau' },
  { value: 'america_kentucky_louisville', label: 'America/Kentucky/Louisville' },
  { value: 'america_kentucky_monticello', label: 'America/Kentucky/Monticello' },
  { value: 'america_kralendijk', label: 'America/Kralendijk' },
  { value: 'america_la_paz', label: 'America/La Paz' },
  { value: 'america_lima', label: 'America/Lima' },
  { value: 'america_los_angeles', label: 'America/Los Angeles' },

];

const MEMBER_ROLES = [
  { value: 'Lead', label: 'Team Lead' },
  { value: 'ScrumMaster', label: 'Scrum Master' },
  { value: 'ProductOwner', label: 'Product Owner' },
  { value: 'Developer', label: 'Developer' },
  { value: 'Designer', label: 'Designer' },
  { value: 'QA', label: 'Quality Assurance' }
];

const AVAILABILITY_OPTIONS = [
  { value: 'fulltime', label: 'Full Time' },
  { value: 'parttime', label: 'Part Time' }
];


// Enhanced Snackbar with custom styling


// Error Boundary Component
class PodManagementErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Pod Management Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{
          p: 3,
          textAlign: 'center',
          color: 'error.main'
        }}>
          <ErrorIcon sx={{ fontSize: 48, mb: 2 }} />
          <Typography variant="h6" gutterBottom>
            Something went wrong
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => window.location.reload()}
          >
            Reload Page
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}




// Constants
const POD_ROLES = ['Scrum Master', "Front-end developer", "Backend developer", "Data engineer", "Data Scientist", "AI Engineer", "Data analyst", "ETL Engineer", "JavaScript Developer", "Python Developer", 'Lead', 'Product Owner', 'Developer', 'Tester', 'DevOps'];
const REGIONS = ['Asia Pacific', 'Latin America', 'North America'];
const PRIMARY_SKILLS = ['html', 'css', 'JavaScript', 'Adobe Illustrator', 'ReactJS', 'AngularJS', 'Java', 'Node.js', 'Vue', 'Next', 'Typescript', 'Gatsby', 'Three.js'];
const SECONDARY_SKILLS = ['Java', 'Python', 'PHP', 'SQL', 'Git', 'c++', 'Perl', 'AngularJS', 'Kotlin', 'AWS', 'NodeJs', 'Azure'];

// Main Component
const ClientManagePod = ({ collapsed }) => {
  const { credentials, isLoaded, isLoading, refresh } = useCredentials();

  const intl = useIntl();
  const theme = useTheme();
  const history = useHistory();
  const location = useLocation();
  const token = useAuthToken();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { user } = useSelector(state => state.auth);
  const { podid } = location.state || {};
  const [editingMember, setEditingMember] = useState(null);
  const [editedMemberData, setEditedMemberData] = useState({
    Pod_Roles: '',
    time_zone: '',
    region: '',
    Primary_Skill: '',
    Secondary_Skill: '',
    Availability: '',

  });
  const config = useMemo(() => ({
    bucketName: credentials.bucketName,
    region: credentials.region,
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey
  }), [credentials]);

  // S3 Configuration
  const s3Config = useMemo(() => ({
    bucketName: credentials.bucketName,
    region: credentials.region,
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey
  }), [credentials]);

  // Fetch both existing team members and available candidates


  // State for error handling
  const [errors, setErrors] = useState({
    main: '',
    upload: '',
    save: ''
  });
  console.log('podid->', podid)
  // State Management
  const [podState, setPodState] = useState({
    podName: '',
    podDescription: '',
    podtype: '',
    techStack: '',
    podSize: '',
    primaryLanguage: '',
    primaryTimezone: '',
    podRate: '',
    pod_ratepermonth: "",
    skills: [],
    candidatesid: [],
    status: 'active',
    talentcheck: 0,
    ART_id: '',
    ART_Name: ''
  });


  const [openSizeDialog, setOpenSizeDialog] = useState(false);
  const [pendingSize, setPendingSize] = useState(null);
  // Review state management
  const [writereview, setWriteReview] = useState('');
  const [rate, setRate] = useState(0);
  const [isSubmittingReview, setIsSubmittingReview] = useState(false);

  // ... [rest of your state management]

  // Review submission handler
  const handleSubmitReview = async () => {
    if (!writereview || rate === 0) {
      showSnackbar('Please provide both review text and rating', 'error');
      return;
    }

    setIsSubmittingReview(true);
    try {
      const body = {
        reviews: writereview,
        rating: rate,
        podID: podid,
        clientID: user.data[0].emp_id,
      };

      const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      };

      await axios.post(process.env.REACT_APP_CLIENT_PODREVIEW, body, { headers });
      showSnackbar('Your review has been submitted successfully!', 'success');
      setWriteReview('');
      setRate(0);
    } catch (error) {
      console.error('Error submitting review:', error);
      showSnackbar('Failed to submit review. Please try again.', 'error');
    } finally {
      setIsSubmittingReview(false);
    }
  };
  // Function to show error
  const showError = (type, message) => {
    setErrors(prev => ({
      ...prev,
      [type]: message
    }));
  };

  // Function to clear error
  const clearError = (type) => {
    setErrors(prev => ({
      ...prev,
      [type]: ''
    }));
  };

  const [ARTOptions, setARTOptions] = useState([]);

  useEffect(() => {
    fetchARTOptions();
  }, [token]);

  const fetchARTOptions = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_CLIENT_FETCHGIGSLIST,
        { Organization_Code: user.data[0].client_code },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data?.data) {
        setARTOptions(Array.isArray(response.data.data) ? response.data.data : []);
      }
    } catch (error) {
      console.error('Error fetching ART options:', error);
    }
  };

  // Function to validate pod size change
  const validatePodSize = (newSize) => {
    const currentMemberCount = teamMembers.length;
    const newSizeNum = parseInt(newSize);

    if (currentMemberCount > newSizeNum) {
      showError('main', `Cannot reduce pod size to ${newSize}. Current team has ${currentMemberCount} members.`);
      return false;
    }
    clearError('main');
    return true;
  };



  // Function to handle adding team members
  const handleAddTeamMember = (newMember) => {
    const currentSize = parseInt(podState.podSize);
    if (teamMembers.length >= currentSize) {
      setError(`Cannot add more members. Pod size limit (${currentSize}) reached.`);
      return false;
    }
    setTeamMembers([...teamMembers, newMember]);
    return true;
  };

  const renderError = (type) => {
    if (!errors[type]) return null;

    return (
      <Alert severity="error" onClose={() => clearError(type)} sx={{ mb: 2 }}>
        <AlertTitle>Error</AlertTitle>
        {errors[type]}
      </Alert>
    );
  };
  const SizeChangeDialog = () => (
    <Dialog
      open={openSizeDialog}
      onClose={() => setOpenSizeDialog(false)}
    >
      <DialogTitle>Cannot Reduce Pod Size</DialogTitle>
      <DialogContent>
        <Typography>
          Current team has {teamMembers.length} members. You need to remove some team members before reducing the pod size to {pendingSize}.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenSizeDialog(false)}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );


  const [imageState, setImageState] = useState({
    imageUrl: '',
    imageFile: null,
    imageKey: '',
    isUploading: false
  });

  const [teamMembers, setTeamMembers] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [loading, setLoading] = useState({
    page: true,
    save: false,
    upload: false
  });
  const [error, setError] = useState({
    main: null,
    upload: null,
    save: null
  });
  const [success, setSuccess] = useState({
    save: false,
    upload: false
  });
  const [openTeamDialog, setOpenTeamDialog] = useState(false);
  const [openRoleDialog, setOpenRoleDialog] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [availableCandidates, setAvailableCandidates] = useState([]);
  const [selectedMember, setSelectedMember] = useState([]);
  const [confirmDialog, setConfirmDialog] = useState({
    title: '',
    message: '',
    onConfirm: () => { }
  });
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedPrimarySkill, setSelectedPrimarySkill] = useState('');
  const [selectedSecondarySkill, setSelectedSecondarySkill] = useState('');
  const [selectedAvailability, setSelectedAvailability] = useState('');
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info',
    key: ''
  });
  // Add this component inside your ClientManagePod component
  const ConfirmationDialog = () => {
    return (
      <Dialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {confirmDialog.title}
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            {confirmDialog.message}
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button
            variant="outlined"
            onClick={() => setOpenConfirmDialog(false)}
            color="inherit"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              confirmDialog.onConfirm();
              setOpenConfirmDialog(false);
            }}
            color="error"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    );
  };



  // Example usage in your remove member function:

  const showSnackbar = (message, severity = 'info') => {

    setSnackbar({
      open: true,
      message,
      severity,
    });
  };
  // S3 Instance
  const s3 = useMemo(() => new AWS.S3(s3Config), []);

  // Initial Data Fetch
  useEffect(() => {
    if (token && podid) {
      fetchPodDetails();
    }
  }, [token, podid]);

  // Fetch Pod Details

  const fetchTeamMembers = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_CLIENT_PODCANDIDATEFETCHING,
        { pods_id: podid },
        { headers: { Authorization: token } }
      );
      setTeamMembers(response.data.data || []);
    } catch (error) {
      console.error('Error fetching team members:', error);
      showSnackbar('Failed to fetch team members', 'error');
    }
  };
  const fetchAvailableCandidates = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_CLIENT_FETCHCANDIDATESBASEDONPODS,
        { pod_id: podid },
        { headers: { Authorization: token } }
      );
      setAvailableCandidates(response.data.data || []);
    } catch (error) {
      console.error('Error fetching available candidates:', error);
    }
  };
  useEffect(() => {
    if (podid && token) {
      fetchTeamMembers();
      fetchAvailableCandidates();
    }
  }, [podid, token]);
  // 2. Add Team Members Dialog with proper checks
  const AddTeamMembersDialog = () => {
    const availableSlots = parseInt(podState.podSize) - teamMembers.length;

    return (
      <Dialog
        open={openTeamDialog}
        onClose={() => setOpenTeamDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Add Team Members ({availableSlots} slots available)
        </DialogTitle>
        <DialogContent>
          {availableSlots <= 0 ? (
            <Alert severity="warning" sx={{ mt: 2 }}>
              <AlertTitle>Maximum Size Reached</AlertTitle>
              Cannot add more members. Please increase pod size or remove existing members.
            </Alert>
          ) : (
            // Your existing team member selection UI
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedCandidates.length === Math.min(availableCandidates.length, availableSlots)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedCandidates(
                              availableCandidates
                                .slice(0, availableSlots)
                                .map(c => c.c_id)
                            );
                          } else {
                            setSelectedCandidates([]);
                          }
                        }}
                      />
                    </TableCell>
                    {/* ... rest of your table headers */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {availableCandidates.map((candidate) => (
                    <TableRow key={candidate.c_id}>
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedCandidates.includes(candidate.c_id)}
                          onChange={() => {
                            if (selectedCandidates.includes(candidate.c_id)) {
                              setSelectedCandidates(
                                selectedCandidates.filter(id => id !== candidate.c_id)
                              );
                            } else if (selectedCandidates.length < availableSlots) {
                              setSelectedCandidates([...selectedCandidates, candidate.c_id]);
                            } else {
                              setError(`Cannot select more than ${availableSlots} members`);
                            }
                          }}
                          disabled={!selectedCandidates.includes(candidate.c_id) &&
                            selectedCandidates.length >= availableSlots}
                        />
                      </TableCell>
                      {/* ... rest of your candidate row cells */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenTeamDialog(false)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleAddTeamMembers}
            disabled={selectedCandidates.length === 0 || availableSlots <= 0}
          >
            Add Selected ({selectedCandidates.length})
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  // 3. Edit Role Dialog with proper checks
  const EditRoleDialog = () => {
    if (!selectedMember) return null;

    return (
      <Dialog
        open={openRoleDialog}
        onClose={() => setOpenRoleDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Edit Team Member Role</DialogTitle>
        <DialogContent>
          <Grid container spacing={3} sx={{ pt: 2 }}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Role</InputLabel>
                <Select
                  value={selectedRole}
                  onChange={(e) => setSelectedRole(e.target.value)}
                  label="Role"
                >
                  {MEMBER_ROLES.map(role => (
                    <MenuItem key={role.value} value={role.value}>
                      {role.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Availability</InputLabel>
                <Select
                  value={selectedAvailability}
                  onChange={(e) => setSelectedAvailability(e.target.value)}
                  label="Availability"
                >
                  {AVAILABILITY_OPTIONS.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenRoleDialog(false)}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleUpdateRole}>
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  // Add this debug function to track state changes
  // Updated image upload handler with proper state management


  // Updated save handler with image key handling
  const [Image, setImage] = useState("");

  // Add this initialization in your component
  useEffect(() => {
    // Initialize imageState when component mounts or podState.picture changes
    if (podState.picture) {
      setImageState(prev => ({
        ...prev,
        imageKey: podState.picture,
        imageUrl: `https://${s3Config.bucketName}.s3.${s3Config.region}.amazonaws.com/${podState.picture}`,
      }));
    }
  }, [podState.picture]);
  const getImageKey = (imageState, podState) => {
    // If we have a new uploaded image, use that
    if (imageState.imageKey) {
      return imageState.imageKey;
    }
    // If we have an existing image in pod state, use that
    if (podState.picture) {
      return podState.picture;
    }
    // Otherwise, we have no image
    return "";
  };

  // Updated save handler with proper image key handling
  const handleSave = async () => {
    setLoading(prev => ({ ...prev, save: true }));
    setError(prev => ({ ...prev, save: null }));

    try {
      const currentImageKey = getImageKey(imageState, podState);

      // Log the current states and image key for debugging
      console.log('Current States:', {
        imageState,
        podState,
        currentImageKey
      });
      // Log states before creating payload
      console.log('Current imageState:', imageState);
      console.log('Current podState:', podState);

      // Get the image key from either state
      const imageKey = imageState.imageKey || podState.picture || "";

      console.log('Using image key for payload:', imageKey);

      const payload = {
        podName: podState.podName,
        pod_rate: podState.podRate || "",
        pod_ratepermonth: podState.pod_ratepermonth || "",
        podtype: podState.podtype || "",
        techStack: podState.techStack || "",
        skills: podState.skills || [],
        podDescription: podState.podDescription || "",
        primary_language: podState.primaryLanguage || "",
        primary_timezone: podState.primaryTimezone || "",
        canID: user.data[0].c_id,
        id: podid,
        candidatesid: [],
        picture: currentImageKey, // Use the determined image key
        podsize: podState.podSize || "",
        talentcheck: podState.talentcheck === 1 ? 1 : 0,
        ART_id: podState.ART_id || "",
        ART_Name: podState.ART_Name || ""
      };

      console.log('Sending payload:', payload);

      const response = await axios.put(
        process.env.REACT_APP_CLIENT_PPODCLIENTUPDATEPOD,
        payload,
        { headers: { Authorization: token } }
      );

      if (response.status === 200) {
        setSuccess(prev => ({ ...prev, save: true }));
        showSnackbar('Pod updated successfully', 'success');
        setTimeout(() => {
          history.push('/FindPodsDetails');
        }, 2000);
      }
    } catch (error) {
      console.error('Error saving pod details:', error);
      const errorMessage = error.response?.data?.message || error.message || 'Failed to save pod details';
      setError(prev => ({
        ...prev,
        save: errorMessage
      }));
      showSnackbar(errorMessage, 'error');
    } finally {
      setLoading(prev => ({ ...prev, save: false }));
    }
  };

  // Add this useEffect to initialize AWS config and set the existing image state
  // Add this useEffect to initialize AWS config and set the existing image state
  // Add this useEffect to initialize AWS config and set the existing image state
  useEffect(() => {
    // Initialize AWS configuration
    AWS.config.update({
      region: credentials.region,
      accessKeyId: credentials.accessKeyId,
      secretAccessKey: credentials.secretAccessKey

    });

    // Initialize image URL if pod has an existing image
    if (podState.picture) {
      setImageState({
        imageUrl: `https://${credentials.region}.s3.${credentials.bucketName}.amazonaws.com/${podState.picture}`,
        imageKey: podState.picture,
        isUploading: false,
        error: null
      });
    }
  }, [podState.picture,]);


  // Update the image upload handler
  // At the top with other styled components


  // Update the handleImageUpload function to show immediate preview
  const handleImageUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Create and show immediate preview
    const previewUrl = URL.createObjectURL(file);
    setImageState(prev => ({
      ...prev,
      imageUrl: previewUrl, // Set local preview URL
      isUploading: true,
      error: null
    }));

    S3FileUpload.uploadFile(file, config)
      .then((data) => {
        // Keep the same preview URL until we confirm S3 URL works
        const location = data.key;
        const s3Url = `https://globldataprod.s3.us-east-1.amazonaws.com/${encodeURIComponent(location)}`;

        // Test if S3 URL is accessible before switching
        const img = new Image();
        img.onload = () => {
          setImageState(prev => ({
            ...prev,
            imageKey: location,
            imageUrl: s3Url,
            isUploading: false
          }));
          URL.revokeObjectURL(previewUrl); // Clean up only after confirming S3 URL works
        };

        img.onerror = () => {
          // Keep the preview URL if S3 URL fails
          setImageState(prev => ({
            ...prev,
            imageKey: location,
            imageUrl: previewUrl,
            isUploading: false
          }));
        };

        img.src = s3Url;

        setPodState(prev => ({
          ...prev,
          picture: location
        }));

        showSnackbar('Image uploaded successfully', 'success');
      })
      .catch((err) => {
        console.error('Error uploading image:', err);
        // Keep showing the preview even if upload fails
        setImageState(prev => ({
          ...prev,
          isUploading: false,
          error: 'Failed to upload image',
          imageUrl: previewUrl // Keep the preview URL on error
        }));
        showSnackbar('Failed to upload image', 'error');
      });
  };
  // Update the image display section


  const renderImageUpload = () => (
    <Box sx={{
      position: 'relative',
      width: 120,
      height: 120,
      margin: '0 auto',
      marginBottom: "3"
    }}>
      {imageState.isUploading && (
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 2
        }}>
          <CircularProgress size={40} />
        </Box>
      )}

      <Avatar
        src={imageState.imageUrl || defaultimg}
        alt={podState.podName || 'Pod Image'}
        sx={{
          width: '100%',
          height: '100%',
          border: '4px solid #fff',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          backgroundColor: theme.palette.grey[100]
        }}
      />

      <IconButton
        component="label"
        disabled={imageState.isUploading}
        sx={{
          position: 'absolute',
          right: -8,
          bottom: -8,
          backgroundColor: theme.palette.primary.main,
          color: '#fff',
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
          }
        }}
      >
        <input
          type="file"
          hidden
          accept="image/jpeg,image/png,image/gif"
          onChange={handleImageUpload}
        />
        <CloudUploadIcon />
      </IconButton>
    </Box>
  );
  // Add this to your fetchPodDetails function
  // Add this function near the top of your component



  // Update the image display section

  // Update your fetchPodDetails function
  const fetchPodDetails = async () => {
    setLoading(prev => ({ ...prev, page: true }));
    try {
      const response = await axios.post(
        process.env.REACT_APP_CLIENT_GETPODID,
        { id: podid },
        { headers: { Authorization: token } }
      );

      if (response.data?.data) {
        const { podDetails } = response.data.data;
        console.log('Full pod details:', podDetails); // For debugging

        // Create safe strings and values
        const podSizeString = podDetails?.podsize !== undefined ? String(podDetails.podsize) : '';

        // Safely handle ART_id - check for both undefined and null

        // Safely handle talentcheck
        const talentcheckValue = podDetails?.talentcheck !== undefined
          ? Number(podDetails.talentcheck)
          : 0;


        // Even safer handling - protects against all falsy values and explicit toString() calls
        const artIdValue = podDetails?.ART_id ? String(podDetails.ART_id) : '';
        const artNameValue = podDetails?.ART_Name ? String(podDetails.ART_Name) : '';
        console.log('ART_id:', artIdValue, 'Type:', typeof artIdValue);
        console.log('ART_Name:', artNameValue, 'Type:', typeof artNameValue);
        // Handle the image
        if (podDetails?.picture) {
          const s3Url = getS3ImageUrl(podDetails.picture);

          if (s3Url) {
            setImageState({
              imageUrl: s3Url,
              imageKey: podDetails.picture,
              isUploading: false,
              error: null
            });
          }
        }

        // Set pod state with safe values
        setPodState({
          podName: podDetails?.podName || '',
          podDescription: podDetails?.podDescription || '',
          podtype: podDetails?.podtype || '',
          techStack: podDetails?.techStack || '',
          podSize: podSizeString,
          primaryLanguage: podDetails?.primary_language || '',
          primaryTimezone: podDetails?.primary_timezone || '',
          podRate: podDetails?.pod_rate || '',
          pod_ratepermonth: podDetails?.pod_ratepermonth || '',
          skills: Array.isArray(podDetails?.skills) ? podDetails.skills : [],
          candidatesid: [],
          status: podDetails?.status || 'active',
          picture: podDetails?.picture || '',
          talentcheck: talentcheckValue,
          ART_id: artIdValue,
          ART_Name: artNameValue
        });

        console.log('Set pod state successfully:', {
          podSize: podSizeString,
          ART_id: artIdValue,
          talentcheck: talentcheckValue,
          ART_Name: artNameValue
        });

      }

    } catch (error) {
      console.error('Error fetching pod details:', error);
      setError(prev => ({
        ...prev,
        main: 'Failed to load pod details. Please try again.'
      }));
    } finally {
      setLoading(prev => ({ ...prev, page: false }));
    }
  };
  const getS3ImageUrl = (imageKey) => {
    if (!imageKey) return null;

    try {
      // Hardcode the known values instead of using environment variables
      const encodedKey = encodeURIComponent(imageKey);
      const url = `https://globldataprod.s3.us-east-1.amazonaws.com/${podState.picture}`;
      console.log('Constructed S3 URL:', url);
      return url;
    } catch (error) {
      console.error('Error constructing S3 URL:', error);
      return null;
    }
  };
  // Update the image display section


  // Updated Image Preview Component
  const ImageUploadPreview = () => {
    return (
      <Box sx={{
        position: 'relative',
        width: 120,
        height: 120,
        margin: '0 auto',
        marginBottom: 3
      }}>
        <Avatar
          src={imageState.imageUrl || defaultimg}
          alt={podState.podName}
          sx={{
            width: '100%',
            height: '100%',
            opacity: imageState.isUploading ? 0.6 : 1,
            border: '4px solid #fff',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            backgroundColor: 'grey.100'
          }}
        />
        {imageState.isUploading && (
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 1
          }}>
            <CircularProgress size={40} />
          </Box>
        )}
        <IconButton
          component="label"
          disabled={loading.upload || imageState.isUploading}
          sx={{
            position: 'absolute',
            right: -8,
            bottom: -8,
            backgroundColor: 'primary.main',
            color: '#fff',
            '&:hover': {
              backgroundColor: 'primary.dark',
            },
            '&.Mui-disabled': {
              backgroundColor: 'grey.400'
            }
          }}
        >
          <input
            type="file"
            hidden
            accept="image/jpeg,image/png,image/gif"
            onChange={handleImageUpload}
          />
          {loading.upload ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            <CloudUploadIcon />
          )}
        </IconButton>
      </Box>
    );
  };
  // Add this at the top of your component with other styled components
  const PodImageUpload = styled(Box)(({ theme }) => ({
    position: 'relative',
    width: 120,
    height: 120,
    margin: '0 auto',
    marginBottom: theme.spacing(3),
    '& .MuiAvatar-root': {
      border: `4px solid ${theme.palette.background.paper}`,
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      backgroundColor: theme.palette.grey[100]
    }
  }));


  // Modified handleInputChange to include size validation
  const handleInputChange = (field) => (event) => {
    const newValue = event.target.value;

    if (field === 'podSize') {
      const isValid = validatePodSize(newValue);
      if (!isValid) {
        setPendingSize(newValue);
        setOpenSizeDialog(true);
        return;
      }
    }

    setPodState(prev => ({
      ...prev,
      [field]: newValue
    }));
    clearError('main');
  };
  const handleSkillChange = (selectedOptions) => {
    setSelectedSkills(selectedOptions);
    setPodState(prev => ({
      ...prev,
      skills: selectedOptions.map(option => ({
        skill: option.label
      }))
    }));
  };

  // Utility Functions
  const calculateMemberCompletion = (member) => {
    let completedFields = 0;
    const totalFields = 5; // role, primary skill, secondary skill, availability, timezoneif (member.role) completedFields++;
    if (member.primarySkill) completedFields++;
    if (member.secondarySkill) completedFields++;
    if (member.availability) completedFields++;
    if (member.timezone) completedFields++;

    return (completedFields / totalFields) * 100;
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const availableSlots = parseInt(podState.podSize) - teamMembers.length;
      const newSelected = availableCandidates
        .slice(0, availableSlots)
        .map(c => c.c_id);
      setSelectedCandidates(newSelected);
    } else {
      setSelectedCandidates([]);
    }
  };
  const handleCandidateSelect = (candidateId) => {
    const selectedIndex = selectedCandidates.indexOf(candidateId);
    let newSelected = [];
    if (selectedIndex === -1) {
      if (selectedCandidates.length < (parseInt(podState.podSize) - teamMembers.length)) {
        newSelected = [...selectedCandidates, candidateId];
      } else {
        showSnackbar('Maximum team size reached', 'warning');
        return;
      }
    } else {
      newSelected = selectedCandidates.filter(id => id !== candidateId);
    }

    setSelectedCandidates(newSelected);
  };
  const handleAddTeamMembers = async () => {
    setLoading(prev => ({ ...prev, addMembers: true }));
    try {
      const response = await axios.post(
        process.env.REACT_APP_CLIENT_ADD_POD_MEMBERS,
        {
          podId: podid,
          memberIds: selectedCandidates
        },
        { headers: { Authorization: token } }
      );
      if (response.status === 200) {
        showSnackbar('Team members added successfully', 'success');
        fetchPodDetails();
        setOpenTeamDialog(false);
        setSelectedCandidates([]);
      }
    } catch (error) {
      console.error('Error adding team members:', error);
      showSnackbar('Failed to add team members', 'error');
    } finally {
      setLoading(prev => ({ ...prev, addMembers: false }));
    }
  };

  const handleEditRole = (member) => {
    setSelectedMember(member);
    setSelectedRole(member.role || '');
    setSelectedPrimarySkill(member.primarySkill || '');
    setSelectedSecondarySkill(member.secondarySkill || '');
    setSelectedAvailability(member.availability || '');
    setOpenRoleDialog(true);
  };
  const handleUpdateRole = async () => {
    try {
      const response = await axios.put(
        process.env.REACT_APP_CLIENT_UPDATE_MEMBER_ROLE,
        {
          podId: podid,
          memberId: selectedMember.c_id,
          role: selectedRole,
          primarySkill: selectedPrimarySkill,
          secondarySkill: selectedSecondarySkill,
          availability: selectedAvailability
        },
        { headers: { Authorization: token } }
      );
      if (response.status === 200) {
        showSnackbar('Member role updated successfully', 'success');
        fetchPodDetails();
        setOpenRoleDialog(false);
      }
    } catch (error) {
      console.error('Error updating member role:', error);
      showSnackbar('Failed to update member role', 'error');
    }
  };

  // Loading State
  if (loading.page) {
    return (
      <Box sx={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 2,
        background: 'var(--artemy-bg-base)',
        color: 'var(--artemy-text-secondary)',
      }}>
        <CircularProgress size={40} sx={{ color: 'var(--artemy-accent)' }} />
        <Typography sx={{ fontSize: '13px', color: 'var(--artemy-text-secondary)' }}>
          Loading pod details...
        </Typography>
      </Box>
    );
  }
  // Error State
  if (error.main) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert
          severity="error"
          action={
            <Button
              color="inherit"
              size="small"
              onClick={fetchPodDetails}
            >
              Retry
            </Button>
          }
        >
          <AlertTitle>Error</AlertTitle>
          {error.main}
        </Alert>
      </Box>
    );
  }





  const handleEditMember = (member) => {
    setEditingMember(member);
    setEditedMemberData({
      Pod_Roles: member.Pod_Roles || '',
      time_zone: member.time_zone || '',
      region: member.region || '',
      Primary_Skill: member.Primary_Skill || '',
      Secondary_Skill: member.Secondary_Skill || '',
      Availability: member.Availability || '',

    });
  };

  const handleSaveMember = async (member) => {
    try {
      const payload = {
        podID: podid,
        candidateID: member.candidateID,
        id: member.id,
        ...editedMemberData,

      };

      await axios.put(
        process.env.REACT_APP_CLIENT_PODCANDIDATEUPDATE,
        payload,
        { headers: { Authorization: token } }
      );

      fetchTeamMembers();
      setEditingMember(null);
      showSnackbar('Team member updated successfully', 'success');
    } catch (error) {
      console.error('Error updating team member:', error);
      showSnackbar('Failed to update team member', 'error');
    }
  };

  const handleRemoveMember = async (member) => {
    try {
      await axios.delete(
        process.env.REACT_APP_CLIENT_PODCANDIDATEDELETE,
        {
          headers: { Authorization: token },
          data: {
            podID: podid,
            candidateId: member.candidateID
          }
        }
      );
      fetchTeamMembers();
      showSnackbar('Team member removed successfully', 'success');
    } catch (error) {
      console.error('Error removing team member:', error);
      showSnackbar('Failed to remove team member', 'error');
    }
  };

  // Render team members grid
  const renderTeamMembers = () => (
    <Grid container spacing={3}>
      {teamMembers.length === 0 ? (
        // Empty state
        <Grid item xs={12}>
          <Box sx={{
            textAlign: 'center',
            py: 8,
            background: 'var(--artemy-bg-card)',
            border: '1px solid var(--artemy-border)',
            borderRadius: 2
          }}>
            <PersonIcon sx={{ fontSize: 48, color: 'var(--artemy-text-dim)', mb: 2 }} />
            <Typography variant="h6" sx={{ color: 'var(--artemy-text-secondary)' }} gutterBottom>
              No Team Members Yet
            </Typography>
            <Typography variant="body2" sx={{ color: 'var(--artemy-text-dim)', mb: 3 }}>
              Visit the 'Find Talent' page to add team members to your pod
            </Typography>
          </Box>
        </Grid>
      ) : (
        // Team members list
        teamMembers.map((member) => (
          <Grid item xs={12} sm={6} md={4} key={member.candidateID}>
            <Card sx={{
              position: 'relative',
              background: 'var(--artemy-bg-card)',
              border: '1px solid var(--artemy-border)',
              borderRadius: '12px',
              boxShadow: 'none',
              transition: 'border-color 0.2s',
              '&:hover': { borderColor: 'var(--artemy-border-bright)' }
            }}>
              <CardContent>
                {/* Member Actions */}
                <Box sx={{ position: 'absolute', right: 8, top: 8 }}>
                  {editingMember?.candidateID === member.candidateID ? (
                    <IconButton onClick={() => handleSaveMember(member)}>
                      <SaveIcon />
                    </IconButton>
                  ) : (
                    <>
                      <IconButton onClick={() => handleEditMember(member)}>
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        color="error"
                        onClick={() => handleRemoveMember(member)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </>
                  )}
                </Box>

                {/* Member Info */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                  <Avatar
                    src={member.profilePicture ?
                      `https://globldataprod.s3.amazonaws.com/${member.profilePicture}` :
                      undefined
                    }
                    alt={member.Candidate_Name}
                  >
                    <PersonIcon />
                  </Avatar>
                  <Box>
                    <Typography variant="subtitle1" fontWeight={600}>
                      {member.Candidate_Name}
                    </Typography>
                    {editingMember?.candidateID === member.candidateID ? (
                      <Select
                        fullWidth
                        size="small"
                        value={editedMemberData.Pod_Roles || ''}
                        onChange={(e) => setEditedMemberData({
                          ...editedMemberData,
                          Pod_Roles: e.target.value
                        })}
                        displayEmpty
                        renderValue={(selected) => {
                          if (!selected) {
                            return <Typography color="text.secondary">Select Role</Typography>;
                          }
                          return selected;
                        }}
                      >
                        <MenuItem disabled value="">
                          <Typography color="text.secondary">Select Role</Typography>
                        </MenuItem>
                        {POD_ROLES.map(role => (
                          <MenuItem key={role} value={role}>
                            {role}
                          </MenuItem>
                        ))}
                      </Select>
                    ) : (
                      <Typography variant="body2" color="textSecondary">
                        {member.Pod_Roles || 'Role not assigned'}
                      </Typography>
                    )}
                  </Box>
                </Box>

                <Divider sx={{ my: 2 }} />

                {/* Skills and Details */}
                <Stack spacing={2}>
                  {editingMember?.candidateID === member.candidateID ? (
                    <>



                      {/* All other Select components will follow the same pattern */}
                      <Select
                        fullWidth
                        size="small"
                        value={editedMemberData.Primary_Skill || ''}
                        onChange={(e) => setEditedMemberData({
                          ...editedMemberData,
                          Primary_Skill: e.target.value
                        })}
                        displayEmpty
                        renderValue={(selected) => {
                          if (!selected) {
                            return <Typography color="text.secondary">Select Primary Skill</Typography>;
                          }
                          return selected;
                        }}
                      >
                        <MenuItem disabled value="">
                          <Typography color="text.secondary">Select Primary Skill</Typography>
                        </MenuItem>
                        {PRIMARY_SKILLS.map(skill => (
                          <MenuItem key={skill} value={skill}>
                            {skill}
                          </MenuItem>
                        ))}
                      </Select>

                      <Select
                        fullWidth
                        size="small"
                        value={editedMemberData.Secondary_Skill || ''}
                        onChange={(e) => setEditedMemberData({
                          ...editedMemberData,
                          Secondary_Skill: e.target.value
                        })}
                        displayEmpty
                        renderValue={(selected) => {
                          if (!selected) {
                            return <Typography color="text.secondary">Select Secondary Skill</Typography>;
                          }
                          return selected;
                        }}
                      >
                        <MenuItem disabled value="">
                          <Typography color="text.secondary">Select Secondary Skill</Typography>
                        </MenuItem>
                        {SECONDARY_SKILLS.map(skill => (
                          <MenuItem key={skill} value={skill}>
                            {skill}
                          </MenuItem>
                        ))}
                      </Select>

                      <Select
                        fullWidth
                        size="small"
                        value={editedMemberData.region || ''}
                        onChange={(e) => setEditedMemberData({
                          ...editedMemberData,
                          region: e.target.value
                        })}
                        displayEmpty
                        renderValue={(selected) => {
                          if (!selected) {
                            return <Typography color="text.secondary">Select Region</Typography>;
                          }
                          return selected;
                        }}
                      >
                        <MenuItem disabled value="">
                          <Typography color="text.secondary">Select Region</Typography>
                        </MenuItem>
                        {REGIONS.map(region => (
                          <MenuItem key={region} value={region}>
                            {region}
                          </MenuItem>
                        ))}
                      </Select>

                      <Select
                        fullWidth
                        size="small"
                        value={editedMemberData.time_zone || ''}
                        onChange={(e) => setEditedMemberData({
                          ...editedMemberData,
                          time_zone: e.target.value
                        })}
                        displayEmpty
                        renderValue={(selected) => {
                          if (!selected) {
                            return <Typography color="text.secondary">{intl.formatMessage({ id: 'selectTimezone' })}</Typography>;
                          }
                          return selected;
                        }}
                      >
                        <MenuItem disabled value="">
                          <Typography color="text.secondary">{intl.formatMessage({ id: 'selectTimezone' })}</Typography>
                        </MenuItem>
                        {TIMEZONES.map(timezone => (
                          <MenuItem key={timezone.value} value={timezone.value}>
                            {timezone.label}
                          </MenuItem>
                        ))}
                      </Select>

                      <Select
                        fullWidth
                        size="small"
                        value={editedMemberData.Availability || ''}
                        onChange={(e) => setEditedMemberData({
                          ...editedMemberData,
                          Availability: e.target.value
                        })}
                        displayEmpty
                        renderValue={(selected) => {
                          if (!selected) {
                            return <Typography color="text.secondary">{intl.formatMessage({ id: 'selectAvailability' })}</Typography>;
                          }
                          return selected;
                        }}
                      >
                        <MenuItem disabled value="">
                          <Typography color="text.secondary">{intl.formatMessage({ id: 'selectAvailability' })}</Typography>
                        </MenuItem>
                        {AVAILABILITY_OPTIONS.map(option => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>

                    </>
                  ) : (
                    <>
                      <Box>
                        <Typography variant="caption" color="textSecondary"> {intl.formatMessage({ id: 'skills' })}</Typography>
                        <Stack direction="row" spacing={1} mt={0.5}>
                          {member.Primary_Skill && (
                            <Chip label={member.Primary_Skill} size="small" />
                          )}
                          {member.Secondary_Skill && (
                            <Chip label={member.Secondary_Skill} size="small" />
                          )}
                        </Stack>
                      </Box>
                      <Box>
                        <Typography variant="caption" color="textSecondary"> {intl.formatMessage({ id: 'region' })}</Typography>
                        <Typography variant="body2">{member.region || 'Not specified'}</Typography>
                      </Box>
                      <Box>
                        <Typography variant="caption" color="textSecondary"> {intl.formatMessage({ id: 'timeZone' })}</Typography>
                        <Typography variant="body2">{member.time_zone || 'Not specified'}</Typography>
                      </Box>
                      <Box>
                        <Typography variant="caption" color="textSecondary"> {intl.formatMessage({ id: 'availability' })}</Typography>
                        <Typography variant="body2">{member.Availability || 'Not specified'}</Typography>
                      </Box>

                    </>
                  )}
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))
      )}
    </Grid>
  );
  // Main Component Return
  return (
    <PageContainer collapsed={collapsed}>
      {/* 1. Breadcrumbs Navigation */}
      <StyledBreadcrumbs>
        <Link to="/FindPodsDetails">
          <Typography sx={{
            fontSize: 14,
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            color: 'var(--artemy-accent)',
          }}>
            <ArrowBackIcon fontSize="small" />
            {intl.formatMessage({ id: 'viewPod' })}
          </Typography>
        </Link>
        <Typography sx={{ fontSize: 14, fontWeight: 600, color: 'var(--artemy-text-secondary)' }}>
          {intl.formatMessage({ id: 'managePod' })}
        </Typography>
      </StyledBreadcrumbs>

      {/* 2. Pod Details Card */}
      <MainCard>
        <CardContent>
          {renderError('main')}
          {/* Pod Header */}
          <Box sx={{ textAlign: 'center', mb: 4, position: 'relative' }}>
            <Typography
              variant="h5"
              fontWeight={700}
              sx={{
                mb: 2,
                color: 'var(--artemy-text-primary)',
                fontFamily: 'var(--artemy-font-display)',
                letterSpacing: '-0.4px',
              }}
            >
              {intl.formatMessage({ id: 'editPod' })}
            </Typography>
            <StatusChip
              label={podState.status.toUpperCase()}
              status={podState.status}
              icon={getStatusIcon(podState.status)}
              sx={{ position: 'absolute', right: 0, top: 0 }}
            />
          </Box>
          {/* {renderImageUpload()} */}
          {/* Replace the existing PodImageUpload section */}

          {/* Pod Image Upload */}
          <ImageUploadComponent
            initialImage={podState.picture}
            onImageChange={(imageKey) => {
              setPodState(prev => ({
                ...prev,
                picture: imageKey
              }));
            }}
            config={s3Config}
            defaultImage={defaultimg}
          />

          {/* Pod Image Upload */}
          {/* <PodImageUpload>
          <StyledAvatar
            src={imageState.imageUrl || defaultimg}
            alt={podState.podName}
          />
          <UploadButton component="label" disabled={loading.upload}>
            <input
              type="file"
              hidden
              accept="image/*"
              onChange={handleImageUpload}
            />
            {loading.upload ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              <CloudUploadIcon />
            )}
          </UploadButton>
        </PodImageUpload> */}

          {/* 3. Form Sections */}
          {/* Basic Information */}

          <FormSection>
            <Typography
              variant="subtitle1"
              fontWeight={600}
              sx={{ mb: 3, color: 'var(--artemy-text-primary)', fontFamily: 'var(--artemy-font-display)' }}
            >
              {intl.formatMessage({ id: 'basicInformation' })}
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <StyledTextField
                  fullWidth
                  label={intl.formatMessage({ id: 'podName' })}
                  value={podState.podName}
                  onChange={handleInputChange('podName')}
                  placeholder="Enter Pod Name"
                  error={Boolean(errors.main && errors.main.includes('name'))}
                  helperText={errors.main && errors.main.includes('name') ? errors.main : ''}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <StyledSelect fullWidth>
                  <InputLabel> {intl.formatMessage({ id: 'podType' })}</InputLabel>
                  <Select
                    value={podState.podtype}
                    onChange={handleInputChange('podtype')}
                    label={intl.formatMessage({ id: 'podType' })}
                    error={Boolean(errors.main && errors.main.includes('type'))}
                  >
                    {POD_TYPES.map(type => (
                      <MenuItem key={type.value} value={type.value}>
                        {type.label}
                      </MenuItem>
                    ))}
                  </Select>
                </StyledSelect>
              </Grid>



              <Grid item xs={12} md={6}>
                <StyledSelect fullWidth>
                  <InputLabel>{intl.formatMessage({ id: 'artProject' })}</InputLabel>
                  <Select
                    value={podState.ART_id ? String(podState.ART_id) : ''}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      const selectedART = ARTOptions?.find(art =>
                        art.ART_id && String(art.ART_id) === selectedId
                      );
                      setPodState(prev => ({
                        ...prev,
                        ART_id: selectedId,
                        ART_Name: selectedART?.ART_Name || ''
                      }));
                    }}
                    label="ART/Project"
                    disabled={!ARTOptions?.length}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {ARTOptions?.map(art => (
                      <MenuItem
                        key={art.ART_id}
                        value={String(art.ART_id)}
                      >
                        {art.ART_Name || `Unnamed ART (ID: ${art.ART_id})`}
                      </MenuItem>
                    ))}
                  </Select>
                </StyledSelect>
                {podState.ART_Name && (
                  <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                    {intl.formatMessage({ id: 'currentARTProject' })}: {podState.ART_Name}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}>
                <StyledTextField
                  fullWidth
                  multiline
                  rows={4}
                  label={intl.formatMessage({ id: 'podDescription' })}
                  value={podState.podDescription}
                  onChange={handleInputChange('podDescription')}
                  placeholder="Enter Pod Description"
                  error={Boolean(errors.main && errors.main.includes('description'))}
                  helperText={errors.main && errors.main.includes('description') ? errors.main : ''}
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={podState.talentcheck === 1}
                    onChange={(e) => {
                      const newValue = e.target.checked ? 1 : 0;
                      console.log('Setting talentcheck to:', newValue);
                      setPodState(prev => ({
                        ...prev,
                        talentcheck: newValue
                      }));
                    }}
                  />
                }
                label={
                  <Typography>
                    {intl.formatMessage({ id: 'hidePodTeamMembers' })} {podState.talentcheck === "1" ? '(Currently Hidden)' : '(Currently Visible)'}
                  </Typography>
                }
              />
            </Grid>
          </FormSection>

          {/* Technical Details Section with Pod Size Validation */}
          <FormSection>
            <Typography
              variant="subtitle1"
              fontWeight={600}
              sx={{ mb: 3, color: 'var(--artemy-text-primary)', fontFamily: 'var(--artemy-font-display)' }}
            >
              {intl.formatMessage({ id: 'technicalDetails' })}
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <StyledSelect fullWidth>
                  <InputLabel>{intl.formatMessage({ id: 'techStack' })}</InputLabel>
                  <Select
                    value={podState.techStack}
                    onChange={handleInputChange('techStack')}
                    label={intl.formatMessage({ id: 'techStack' })}
                    error={Boolean(errors.main && errors.main.includes('tech stack'))}
                  >
                    {TECH_STACKS.map(stack => (
                      <MenuItem key={stack.value} value={stack.value}>
                        {stack.label}
                      </MenuItem>
                    ))}
                  </Select>
                </StyledSelect>
              </Grid>
              <Grid item xs={12} md={6}>
                <StyledSelect fullWidth>
                  <InputLabel> {intl.formatMessage({ id: 'podSize' })}</InputLabel>
                  <Select
                    value={podState.podSize}
                    onChange={handleInputChange('podSize')}
                    label={intl.formatMessage({ id: 'podSize' })}
                    error={Boolean(errors.main && errors.main.includes('size'))}
                  >
                    {POD_SIZES.map(size => (
                      <MenuItem key={size.value} value={size.value}>
                        {size.label}
                        {teamMembers.length > 0 && (
                          <Typography component="span" color="text.secondary" sx={{ ml: 1 }}>
                            ({teamMembers.length}/{size.value})
                          </Typography>
                        )}
                      </MenuItem>
                    ))}
                  </Select>
                </StyledSelect>
                <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                  {intl.formatMessage({ id: 'currentTeamSize' })}: {teamMembers.length} members
                </Typography>
              </Grid>
            </Grid>
          </FormSection>

          {/* Communication Details Section */}
          <FormSection>
            <Typography variant="h6" fontWeight={600} sx={{ mb: 3 }}>
              {intl.formatMessage({ id: 'communicationDetails' })}
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <StyledSelect fullWidth>
                  <InputLabel> {intl.formatMessage({ id: 'primaryLanguage' })}</InputLabel>
                  <Select
                    value={podState.primaryLanguage}
                    onChange={handleInputChange('primaryLanguage')}
                    label={intl.formatMessage({ id: 'primaryLanguage' })}
                  >
                    {PRIMARY_LANGUAGES.map(language => (
                      <MenuItem key={language.value} value={language.value}>
                        {language.label}
                      </MenuItem>
                    ))}
                  </Select>
                </StyledSelect>
              </Grid>
              <Grid item xs={12} md={6}>
                <StyledTextField
                  fullWidth
                  label={intl.formatMessage({ id: 'ratePerHour' })}
                  value={podState.podRate}
                  onChange={handleInputChange('podRate')}
                  placeholder="Enter hourly rate"
                  type="number"
                  InputProps={{
                    startAdornment: <Typography sx={{ mr: 1 }}>$</Typography>,
                  }}
                  error={Boolean(errors.main && errors.main.includes('rate'))}
                  helperText={errors.main && errors.main.includes('rate') ? errors.main : ''}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <StyledTextField
                  fullWidth
                  label={intl.formatMessage({ id: 'ratePerMonth' })}
                  value={podState.pod_ratepermonth}
                  onChange={handleInputChange('pod_ratepermonth')}
                  placeholder="Enter hourly rate"
                  type="number"
                  InputProps={{
                    startAdornment: <Typography sx={{ mr: 1 }}>$</Typography>,
                  }}
                  error={Boolean(errors.main && errors.main.includes('rate'))}
                  helperText={errors.main && errors.main.includes('rate') ? errors.main : ''}
                />
              </Grid>



              <Grid item xs={12} md={6}>
                <StyledSelect fullWidth>
                  <InputLabel>{intl.formatMessage({ id: 'timeZone' })}</InputLabel>
                  <Select
                    value={podState.timezone}
                    onChange={handleInputChange('timezone')}
                    label={intl.formatMessage({ id: 'timeZone' })}
                  >
                    {TIMEZONES.map(timezone => (
                      <MenuItem key={timezone.value} value={timezone.value}>
                        {timezone.label}
                      </MenuItem>
                    ))}
                  </Select>
                </StyledSelect>
              </Grid>
            </Grid>
          </FormSection>



          {/* 4. Team Members Section */}
          <MainCard sx={{ mt: 4 }}>
            <CardContent>
              <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 3
              }}>
                <Typography
                  variant="h6"
                  fontWeight={700}
                  sx={{
                    color: 'var(--artemy-text-primary)',
                    fontFamily: 'var(--artemy-font-display)',
                  }}
                >
                  {intl.formatMessage({ id: 'teamMember' })} ({teamMembers.length}/{podState.podSize})
                </Typography>
              </Box>

              {renderTeamMembers()}
            </CardContent>
          </MainCard>

          {/* 5. Action Buttons */}
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            mt: 4
          }}>
            <ActionButton
              variant="outlined"
              onClick={() => history.goBack()}
              startIcon={<CloseIcon />}
            >
              {intl.formatMessage({ id: 'cancel' })}
            </ActionButton>
            <ActionButton
              onClick={handleSave}
              disabled={loading.save}
              startIcon={loading.save ?
                <CircularProgress size={20} /> :
                <SaveIcon />
              }
            >
              {intl.formatMessage({ id: 'saveChanges' })}
            </ActionButton>
          </Box>
        </CardContent>
      </MainCard>
      {/* Pod Review Section */}
      <MainCard sx={{ mt: 4 }}>
        <CardContent>
          <Typography variant="h5" fontWeight={600} sx={{ mb: 3 }}>
            {intl.formatMessage({ id: 'podReview' })}
          </Typography>

          <FormSection>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    {intl.formatMessage({ id: 'rating' })}
                  </Typography>
                  <Stack direction="row" spacing={1}>
                    {[1, 2, 3, 4, 5].map((value) => (
                      <IconButton
                        key={value}
                        onClick={() => setRate(value)}
                        sx={{
                          color: value <= rate ? 'primary.main' : 'grey.300',
                          '&:hover': {
                            backgroundColor: 'transparent',
                            color: 'primary.main'
                          }
                        }}
                      >
                        <StarIcon />
                      </IconButton>
                    ))}
                  </Stack>
                </Box>

                <StyledTextField
                  fullWidth
                  multiline
                  rows={4}
                  label="Write Review"
                  value={writereview}
                  onChange={(e) => setWriteReview(e.target.value)}
                  placeholder={intl.formatMessage({ id: 'shareYourExperience' })}
                  sx={{ mb: 2 }}
                />

                <ActionButton
                  onClick={handleSubmitReview}
                  disabled={isSubmittingReview || !writereview || rate === 0}
                  startIcon={isSubmittingReview ? <CircularProgress size={20} /> : <SendIcon />}
                >
                  {intl.formatMessage({ id: 'teamMember' })}
                </ActionButton>
              </Grid>
            </Grid>
          </FormSection>
        </CardContent>
      </MainCard>
      {/* 6. Dialogs */}
      <AddTeamMembersDialog />
      <EditRoleDialog />
      <ConfirmationDialog />

      {/* 7. Notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>


    </PageContainer>
  );
}
export default ClientManagePod;
